module.exports = __webpack_public_path__ + "static/img/rocket.2dea8fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rocket.png
// module id = g9no
// module chunks = 1